"use client";

import React from "react";
const partners = [{
  id: 1,
  name: "ISCC Certification",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/logo_iscc_compliance.png"
}, {
  id: 2,
  name: "Lloyd's Register",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/logo_lloyds_register.png"
}, {
  id: 3,
  name: "Hong Kong Maritime",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/logo_hk_maritime_authority.png"
}, {
  id: 4,
  name: "Global Biofuel Board",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/logo_biofuel_board.png"
}, {
  id: 5,
  name: "SGS Inspection",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/logo_sgs_industrial.png"
}, {
  id: 6,
  name: "Intertek Quality",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/logo_intertek_testing.png"
}, {
  id: 7,
  name: "Maritime Logistics Association",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/logo_maritime_logistics.png"
}];
export default function InstitutionalTrustSignals() {
  return;
}